module.exports = __webpack_public_path__ + "img/hourglass.c103227b.svg";